<template>
	<article class="article-block" v-if="content">
		<h2 class="detail-infos__subheading--label"><slot /></h2>

		<div v-html="content" />
	</article>
</template>

<script setup lang="ts">
defineProps<{
	content: string | null | undefined;
}>();
</script>

<style lang="scss" scoped>
@import '@/styles/sports.scss';

h2,
h3,
p {
	margin: 0;
	padding: 0;
}
.article-block {
	margin-block: 48px;

	:deep(h3) {
		font-size: 16px;
		font-weight: 900;
		line-height: 24px;
		color: $color-neutral-light;
		margin: 0;
		margin-top: 16px;
	}

	:deep(p) {
		font-size: 16px;
		font-weight: 500;
		line-height: 150%;
		color: $color-text;
		margin-top: 16px;
	}
}
</style>
